import { NgModule } from '@angular/core';
import { StoreModule, Store } from '@ngrx/store';
import { EffectsModule, Actions, EffectSources } from '@ngrx/effects';

import { ReducersConfigurator, ReducersRepository } from './reducers/index';
import { EffectsConfigurator, EffectsRepository  } from './effects/index';

export class ProviderFactory {

    public static createReducersConfigurator(
        store: Store<any>,
        reducersRepository: ReducersRepository
    ): ReducersConfigurator {

        return new ReducersConfigurator(store, reducersRepository);
    }

    public static createEffectsConfigurator(
        effectsRepository: EffectsRepository,
        actions$: Actions,
        store: Store<any>
    ): EffectsConfigurator {

        return new EffectsConfigurator(effectsRepository, actions$, store);
    }
}

@NgModule({

    imports: [
        StoreModule.forRoot({}),
        EffectsModule.forRoot([])
    ],

    providers: [{
        provide: ReducersConfigurator,
        useFactory: ProviderFactory.createReducersConfigurator,
        deps: [
            Store,
            ReducersRepository
        ]
    }, {
        provide: EffectsConfigurator,
        useFactory: ProviderFactory.createEffectsConfigurator,
        deps: [
            EffectsRepository,
            Actions,
            Store,
            EffectSources,
        ]
    },
    EffectsRepository,
    ReducersRepository,
    ],

    exports: [
        StoreModule
    ]
})
export class InternalsModule {}
